document.addEventListener('DOMContentLoaded', function() {
  const sizeGuideTrigger = document.querySelector('[data-size-guide-trigger]');
  const sizeGuideDrawer = document.getElementById('size-guide-drawer');
  const sizeGuidePanel = document.getElementById('size-guide-panel');
  const sizeGuideOverlay = document.getElementById('size-guide-overlay');
  const closeSizeGuide = document.getElementById('close-size-guide');
  const unitToggles = document.querySelectorAll('[data-unit-toggle]');
  const sizeCharts = document.querySelectorAll('[data-size-chart]');
  const sizeGuideTitle = document.querySelector('[data-size-guide-title]');

  // Function to convert measurements
  function convertMeasurements(unit) {
    document.querySelectorAll('[data-size-row]').forEach(row => {
      row.querySelectorAll('[data-inches]').forEach(cell => {
        const inches = cell.dataset.inches;
        const cm = cell.dataset.cm;
        cell.textContent = unit === 'inches' ? `${inches} inches` : `${cm} cm`;
      });
    });

    // Update toggle buttons
    unitToggles.forEach(toggle => {
      if (toggle.dataset.unit === unit) {
        toggle.classList.add('border-b', 'border-black');
        toggle.classList.remove('text-black/40');
      } else {
        toggle.classList.remove('border-b', 'border-black');
        toggle.classList.add('text-black/40');
      }
    });
  }

  // Show appropriate size chart based on product type
  function showSizeChart(productType) {
    sizeCharts.forEach(chart => {
      if (chart.dataset.sizeChart === productType) {
        chart.classList.remove('hidden');
        sizeGuideTitle.textContent = productType === 'shoes' ? 'Shoes Size Guide' : 'Abaya Size Guide';
      } else {
        chart.classList.add('hidden');
      }
    });
  }

  if (sizeGuideTrigger && sizeGuideDrawer && sizeGuidePanel && sizeGuideOverlay && closeSizeGuide) {
    function toggleSizeGuide() {
      const isHidden = sizeGuideDrawer.classList.contains('invisible');
      
      if (isHidden) {
        sizeGuideDrawer.classList.remove('invisible', 'opacity-0');
        sizeGuidePanel.classList.remove('translate-x-full');
        document.body.style.overflow = 'hidden';

        // Determine product type and show appropriate chart
        const productType = sizeGuideTrigger.dataset.productType || 'clothing';
        showSizeChart(productType);
      } else {
        sizeGuideDrawer.classList.add('opacity-0');
        sizeGuidePanel.classList.add('translate-x-full');
        document.body.style.overflow = '';
        setTimeout(() => {
          sizeGuideDrawer.classList.add('invisible');
        }, 500);
      }
    }

    sizeGuideTrigger.addEventListener('click', toggleSizeGuide);
    closeSizeGuide.addEventListener('click', toggleSizeGuide);
    sizeGuideOverlay.addEventListener('click', toggleSizeGuide);

    // Unit toggle functionality
    unitToggles.forEach(toggle => {
      toggle.addEventListener('click', () => {
        convertMeasurements(toggle.dataset.unit);
      });
    });
  }
}); 